module.exports = __webpack_public_path__ + "static/diyanet3-ebd1f56c64397366336e88c60de86af2.png";